var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoPinkIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 0C6.26221 0 0 6.2615 0 14C0 21.7377 6.2615 28 14 28C21.7378 28 28 21.7385 28 14C28 6.26232 21.7385 0 14 0ZM15.4377 19.5574C15.4377 19.9997 14.7927 20.4419 14.0003 20.4419C13.171 20.4419 12.5814 19.9997 12.5814 19.5574V12.5362C12.5814 12.0203 13.171 11.67 14.0003 11.67C14.7927 11.67 15.4377 12.0203 15.4377 12.5362V19.5574ZM14.0003 9.97478C13.1526 9.97478 12.4893 9.34823 12.4893 8.6479C12.4893 7.94762 13.1527 7.3395 14.0003 7.3395C14.8296 7.3395 15.4931 7.94762 15.4931 8.6479C15.4931 9.34823 14.8296 9.97478 14.0003 9.97478Z",
    fill: "#FF0990"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoPinkIcon);
export default __webpack_public_path__ + "static/media/info-pink-icon.56ceffef21e15dbd36c45d685e1f21e6.svg";
export { ForwardRef as ReactComponent };